'use client';

import React from 'react';
import { ProductStockStatus, RECENTLY_VIEWED_PRODUCTS_KEY } from '@skin-seoul/service';
import SkinSeoulSelectsSection from '../SkinSeoulSelectsSection/SkinSeoulSelectsSection';
import Cookies from 'js-cookie';
import { useProductService } from '@skin-seoul/service';
import { useRegionCurrency } from '@skin-seoul/service';
const ConditionalSkinSeoulSelectsSection = () => {
  /**
   * Read recently viewed product ids from cookie. Remove cookie if invalid.
   */
  const rawRecentlyViewed = Cookies.get(RECENTLY_VIEWED_PRODUCTS_KEY);
  const recentlyViewedIds = rawRecentlyViewed?.split('|').filter(Boolean) || [];
  if (!rawRecentlyViewed || recentlyViewedIds.length === 0) {
    Cookies.remove(RECENTLY_VIEWED_PRODUCTS_KEY);
  }
  const {
    currency
  } = useRegionCurrency();
  const {
    useGetSuspenseProductsByIds: useGetProductsByIds
  } = useProductService();
  const {
    data: recentlyViewedData
  } = useGetProductsByIds({
    ids: recentlyViewedIds.join(','),
    currency
  });
  const filteredRecentlyViewedProducts = recentlyViewedData?.filter(product => product.status === ProductStockStatus.instock);
  if (filteredRecentlyViewedProducts?.length > 0) {
    return <SkinSeoulSelectsSection />;
  }
  return null;
};
export default ConditionalSkinSeoulSelectsSection;